import style from './index.scss';
import { Component } from 'preact';
import SubHeader from '../layout/subheader/';
import { Link } from 'preact-router/match';
import {SlidingPuzzle} from 'react-puzzle';

class SlidePuzzle extends Component {
	ref = null;
	setRef = (dom) => this.ref = dom;
	constructor(props) {
		super(props)
		this.state = {
			started: false,
			moves:0,
			solved:false
		}
	}
	componentWillMount(props){

	}
	componentDidMount(){
	}

	render(){
		let basepath = window.location.host.includes('localhost') ? '/' : '/';
		return (
			<div>
				{ this.props.matches['activity-id']}

				<SlidingPuzzle ref={this.setRef} src='https://scontent-lhr8-1.cdninstagram.com/v/t51.2885-15/sh0.08/e35/s640x640/55906307_2260339794189784_8427209178500981818_n.jpg?_nc_ht=scontent-lhr8-1.cdninstagram.com&_nc_cat=104&_nc_ohc=MUmrdqma0vUAX_cb7dO&oh=fa7d4b4fd2b8abf1cddb43911aea3ed5&oe=5ECCA66A' rows={3} cols={3}
					   onMove={()=>{
						   this.setState({ moves: this.state.moves +1})
					   }}
					   onSolve={()=>{
						   this.setState({ solved: true })
					   }}
				/>


				<p style={{ textAlign: 'center', width: '100%',float: 'left',clear: 'both' }}>
					<button className="button green" onClick={()=>{
						this.ref.shuffle();
						this.setState({started:true, moves: 0, solved: false})
					}}>{this.state.started ? 'Restart' : 'Start'}</button>
				</p>
				<p style={{ textAlign: 'center', width: '100%',float: 'left',clear: 'both' }}>
					{this.state.solved ? 'Solved in ' : ''}{this.state.moves} moves
				</p>
				<p style={{ textAlign: 'center', width: '100%',float: 'left',clear: 'both' }}>
					Click "Start" to start, then click a piece to move it to the empty space. The aim is to slide the pieces top get the puzzle back together
				</p>

			</div>
		);
	}
}

export default SlidePuzzle;



// WEBPACK FOOTER //
// ./components/puzzle/index.js